#import "./cartFragment.gql"

mutation addLinesMutation($id: ID!, $lines: [CartLineInput!]!, $lang: LanguageCode!) @inContext(language: $lang) {
  cartLinesAdd(cartId: $id, lines: $lines) {
    cart {
      ...cartFragment
    }
    userErrors {
      field
      message
    }
  }
}
